import { render, staticRenderFns } from "./borrowApplyDialog.vue?vue&type=template&id=f2d8887e&scoped=true&"
import script from "./borrowApplyDialog.vue?vue&type=script&lang=js&"
export * from "./borrowApplyDialog.vue?vue&type=script&lang=js&"
import style0 from "./borrowApplyDialog.vue?vue&type=style&index=0&id=f2d8887e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d8887e",
  null
  
)

export default component.exports